export const GENDERS = ['MALE', 'FEMALE', 'OTHER', 'NOT_SAY'] as const;
export const TITLE = 'Alva Labs AB' as const;
